import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { I18nProvider } from "@/contexts/I18nContext";
import { EditModeProvider } from "@/contexts/EditModeContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <I18nProvider>
      <EditModeProvider>
        <App />
      </EditModeProvider>
    </I18nProvider>
  </React.StrictMode>,
);
